import { AppBrand } from '@ts-brand/enums'

interface AppBrandReturn {
  isSmartestMinds: boolean
}

export const useAppBrand = (): AppBrandReturn => ({
  isSmartestMinds: useRuntimeConfig().public.brand === AppBrand.SmartestMinds,
})
